import React from 'react';
import { ChevronsDown, Flame } from 'lucide-react';
import classNames from 'classnames';
import { VariantBadgeT } from '@/lib/collections/catalogue/helpers';

const generateBadgeConfig = (
  badge: { value: string; name: string },
  oldPdp: boolean,
) => {
  if (badge.value === 'limited-deal') {
    return {
      colors: {
        main: '#E20A45',
        secondary: '#FFE9E9',
      },
      label: badge.name,
      icon: (
        <Flame
          className={classNames({
            'mt-[3px] h-2.5 w-2.5 shrink-0': !oldPdp,
            'h-2.5 w-2.5': oldPdp,
          })}
          style={{ fill: '#E20A45' }}
        />
      ),
    };
  }

  if (badge.value === 'special-deal') {
    return {
      colors: {
        main: '#116A43',
        secondary: '#E4F9EF',
      },
      label: badge.name,
      icon: (
        <div className="mt-[3px] flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full bg-[#116A43]">
          <ChevronsDown className="h-2 w-2 text-white" />
        </div>
      ),
    };
  }

  return null;
};

export default function VariantBadge({
  badge,
  oldPdp = false,
  hide = false,
}: {
  badge: VariantBadgeT | undefined;
  oldPdp?: boolean;
  hide?: boolean;
}) {
  if (!badge || hide) return null;

  const config = generateBadgeConfig(badge, oldPdp);

  if (!config) return null;

  if (oldPdp) {
    return (
      <div
        className="flex h-6 w-fit items-center gap-1 rounded-full p-2 text-xxs font-bold"
        // eslint-disable-next-line react/forbid-dom-props
        style={{
          backgroundColor: config.colors.secondary,
          color: config.colors.main,
        }}
      >
        {config.icon}
        {config.label}
      </div>
    );
  }

  return (
    <div
      className="absolute bottom-[-17px] left-1/2 z-10 flex h-4 w-[95%] -translate-x-1/2 gap-x-1 rounded-b px-1 text-[9px] font-bold"
      // eslint-disable-next-line react/forbid-dom-props
      style={{
        backgroundColor: config.colors.secondary,
        color: config.colors.main,
      }}
    >
      {config.icon}
      <span className="mt-[1px] shrink-0">{config.label}</span>
    </div>
  );
}
